import { render, staticRenderFns } from "./HtmlItem.vue?vue&type=template&id=596a12fe&scoped=true&"
import script from "./HtmlItem.vue?vue&type=script&lang=js&"
export * from "./HtmlItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a12fe",
  null
  
)

export default component.exports